import { render, staticRenderFns } from "./mgqj.vue?vue&type=template&id=d30513da&scoped=true&"
import script from "./mgqj.vue?vue&type=script&lang=js&"
export * from "./mgqj.vue?vue&type=script&lang=js&"
import style0 from "./mgqj.vue?vue&type=style&index=0&id=d30513da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30513da",
  null
  
)

export default component.exports